/**
 * Root component of `apps/web` — Phase 5.
 *
 * Integrates TanStack Router as the navigation layer within the
 * data providers (Query + PowerSync).
 /** Waits for the app to finish booting (skeleton overlay disappears). */

import { type Component, Suspense } from "solid-js";
import { RouterProvider } from "@tanstack/solid-router";

import { AppProviders } from "@/providers/app-providers";
import { router } from "@/router";

export const App: Component = () => (
  <Suspense fallback={null}>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </Suspense>
);
